jQuery(document).ready(function() {
   var $ = jQuery.noConflict();
   return;
   view_course(1);
    let check = 0;
    check = setInterval(function() {
        if (jQuery('a#link-to-evaluation_scores').length > 0) {
            clearInterval(check);
            jQuery('a#link-to-evaluation_scores').click();
        }
    },500);
});
function add_course(afterAdd) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/course/add',
        onOpen: function (elm, popup) {

            elm.find('[data-course-selector]').courseSelector();
            elm.find('select#refresher_course_id').change(function() {
                if($(this).val() == -1) {
                    elm.find('.show-for-refresher-only').hide();
                } else {
                    elm.find('.show-for-refresher-only').show();
                }
            }).trigger('change');


            elm.find('[data-product-selector]').productSelector();

            elm.find('form').ajaxFormSubmit(function(data){
                reload_location_if_needed(true);
                if (!document.closeWindow) {
                    open_new_object(view_course, data)
                }
                if(afterAdd) {
                    afterAdd(data, elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_course(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    confirm("Weet u zeker dat u \""+name+"\" wilt verwijderen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/course/delete",
            data: {id:id},
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'course\'][data-id=\''+id+'\'').remove();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}
function view_course(id, vars) {
    var $ = jQuery.noConflict();

    if(vars != undefined && typeof vars == "function") {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/course/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('#general').find('[data-course-selector]').courseSelector();
            elm.find('#checklist').find('[data-checklist-selector]').checklistSelector();
            initiate_evaluation_statistics(elm);
            elm.find('select#refresher_course_id').change(function() {
                if($(this).val() == -1) {
                    elm.find('.show-for-refresher-only').hide();
                } else {
                    elm.find('.show-for-refresher-only').show();
                }
            }).trigger('change');

            elm.find('[data-product-selector]').productSelector();

            elm.find('form').ajaxFormSubmit(function(data){
                squde_reload_for_flashes();

                $('body').doneLoading();
                reload_location_if_needed(document.closeWindow);
                if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function disable_course(id, name) {
    const $ = jQuery.noConflict();
    name = decodeURI(name);
    confirm(`Weet u zeker dat u ${name} wilt deactiveren?`, () => {
        $('body').isLoading('dark');
        $.ajax({
            url: `/course/deactivate/${id}`,
            type: "POST",
            success: function() {
                reload_location_if_needed(false);
                $('body').doneLoading();

                foundationPopup(`
<div class="text-center">
    De cursus is gedeactiveerd.
    <br />
    Controleer zelf of deze cursus nog is gepland of als herhaling of alternatief is ingesteld.
    <br />
    <br />
    <a href="#" class="button primary close-reveal-modal">Sluiten</a>
</div>
`, undefined, 'tiny')
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}
function enable_course(id) {
    const $ = jQuery.noConflict();
    $.ajax({
        url: `/course/activate/${id}`,
        type: "POST",
        success: function() {
            reload_location_if_needed(false);
            $('body').doneLoading();
        },
        error: function(e) {
            $('body').doneLoading();
            squde_flash("Er ging helaas iets mis.", "alert");
        }
    });
}
